<div class="pin-pad">
  <div class="pin-pad__logo">
    <img
      ngSrc="assets/images/pool-logo.svg"
      alt="logo"
      priority="high"
      width="150"
      height="75"
    />
  </div>

  <div class="pin-pad__content">
    <div class="pin-pad__indicators">
      @for (item of getIndicators(); track item) {
        <div
          class="pin-pad__indicator"
          [ngClass]="{ 'pin-pad__indicator--filled': pinCode().length > item }"
        ></div>
      }
    </div>

    @if (linkedErrorTranslateKey(); as errorKey) {
      <p class="pin-pad__title pin-pad__title--error">
        {{ errorKey | translate }}
      </p>
    } @else {
      <p class="pin-pad__title">
        {{ titleTranslateKey() | translate }}
      </p>
    }

    <div class="pin-pad__keyboard">
      @for (row of keyboard; track $index) {
        <div class="pin-pad__keyboard-row">
          @for (num of row; track num) {
            <button
              class="pin-pad__key"
              (click)="onNumberClick(num)"
              type="button"
            >
              {{ num }}
            </button>
          }
        </div>
      }

      <div class="pin-pad__keyboard-row">
        @if (showBiometric() && biometricAvailable()) {
          <button
            class="pin-pad__key pin-pad__key--icon"
            (click)="onBiometric()"
            type="button"
          >
            <lib-svg-icon size="28" icon="fingerprint" />
          </button>
        } @else {
          <div class="pin-pad__key pin-pad__key--empty"></div>
        }

        <button class="pin-pad__key" (click)="onNumberClick(0)" type="button">
          0
        </button>

        <button
          class="pin-pad__key pin-pad__key--icon"
          (click)="onDelete()"
          type="button"
        >
          <lib-svg-icon size="28" icon="remove-tag" />
        </button>
      </div>
    </div>
  </div>

  @if (showLogout()) {
    <button class="pin-pad__help" (click)="onLogout()" type="button">
      {{ logoutTextKey() | translate }}
    </button>
  } @else {
    <div class="pin-pad__spacer"></div>
  }
</div>
